export default "__VITE_ASSET__bLtuq$xH__"